/// <reference types="react/next" />
/// <reference types="react-dom/next" />

import "regenerator-runtime/runtime";
import "core-js/stable";
import "whatwg-fetch";
import "./polyfills";

if (!HTMLElement.prototype.remove) {
	HTMLElement.prototype.remove = function() {
		if (this.parentNode) this.parentNode.removeChild(this);
	}
}

import React from 'react';
import ReactDOM, { flushSync } from 'react-dom';
import coreBlocks, { Registry as BlockRegistry } from '@sightworks/block';
import theme from './theme';
import { preload } from '@sightworks/theme';
import { Blocks as FormBlocks } from '@sightworks/form';
import { PageProps } from '@sightworks/block';
import JsonFormat from './json';
// import OverlayScroller from "./overlay-scroller";

BlockRegistry.addBlocks(coreBlocks);
BlockRegistry.addBlocks(FormBlocks);
BlockRegistry.setTheme(theme);

let forcedTheme: string = null;
export function forceTheme(id: string) {
	forcedTheme = id;
}

declare const __webpack_require__: {
	(name: string): any;
	m: Record<string, any>
}

function Main({ rootProps }: { rootProps: PageProps }) {
	React.useEffect(() => {
		const jssStyles = document.querySelector('#jss-server-side');
		if (jssStyles) {
			jssStyles.parentNode.removeChild(jssStyles);
		}
	}, []);

	const Page = coreBlocks.page;
	if (forcedTheme) rootProps.useNamedTheme = forcedTheme;
	return React.createElement(Page().component, rootProps);
}

type PageObject = {
	props: PageProps;
	path: string;
	title: string;
	description: string;
	keywords: string;
}

export async function json(body: any) {
	ReactDOM.createRoot(document.querySelector('#json')).render(<JsonFormat target={body}/>);
}

let root: ReactDOM.Root;

export async function run(path: string, preloads: (() => void)[] = [], json?: any) {
	preloads.forEach(item => item());
	
	window.addEventListener('popstate', event => {
		if (event.state) {
			update(event.state.path, event.state, false);
		}
	});

	let rootProps: PageObject = history.state;
	let hydrate = true;
	let doFetch = async () => {};
	
	if (json) {
		rootProps = json;
	} else {
		let req = await fetch(path);
		rootProps = await req.json();
	}
	hydrate = true;
	await preload(rootProps.props);
	if (!rootProps.path) {
		rootProps.path = location.href;
	}
	if (history.replaceState) {
		try {
			history.replaceState(rootProps, rootProps.title, rootProps.path);
		} catch (e) {
			;
		}
	}

	root = ReactDOM.createRoot(document.querySelector('#root'), { hydrate });
	if (forcedTheme || !hydrate) {
		document.querySelector('#root').innerHTML = "";
		document.querySelector('title').textContent = rootProps.title;
		document.querySelector<HTMLMetaElement>('meta[name=description]').content = rootProps.description;
		document.querySelector<HTMLMetaElement>('meta[name=keywords]').content = rootProps.keywords;
	}
	root.render(<Main rootProps={rootProps.props}/>);

	await doFetch();
}

export async function runWithObject(rootProps: PageObject, preloads: (() => void)[] = []) {
	preloads.forEach(item => item());

	let hydrate = false;	
	await preload(rootProps.props);
	if (!rootProps.path) {
		rootProps.path = location.href;
	}	

	root = ReactDOM.createRoot(document.querySelector('#root'), { hydrate });
	if (forcedTheme || !hydrate) {
		document.querySelector('#root').innerHTML = "";
		document.querySelector('title').textContent = rootProps.title;
		document.querySelector<HTMLMetaElement>('meta[name=description]').content = rootProps.description;
		document.querySelector<HTMLMetaElement>('meta[name=keywords]').content = rootProps.keywords;
	}
	root.render(<Main rootProps={rootProps.props}/>);

	// This is primaril	y used on preview pages, so...
	window.addEventListener('cleanup', event => {
		flushSync(() => {
			root.unmount();
			console.log('cleanup done on preview window');
		});
	});
}

export async function update(path: string, props: PageObject = null, pushState = true) {
	if (history.pushState) {
		let baseHref = document.querySelector('base').href;
		if (path.startsWith(baseHref)) {
			let suffix = path.substring(baseHref.length);
			let rootProps = props;
			if (!props) {
				let req = await fetch(baseHref + 'json/' + suffix);
				rootProps = await req.json();
			}
			await preload(rootProps.props);
			rootProps.path = path;
			document.querySelector('title').textContent = rootProps.title;
			document.querySelector<HTMLMetaElement>('meta[name=description]').content = rootProps.description;
			document.querySelector<HTMLMetaElement>('meta[name=keywords]').content = rootProps.keywords;
			if (pushState) {
				try {
					history.pushState(rootProps, rootProps.title, path);
				} catch (e) {
					;
				}
			}
			root.render(<Main rootProps={rootProps.props}/>);
		}
	}
}

BlockRegistry.setUpdater(update);

export default __webpack_require__;

export const ENV = {
	NODE_ENV: process.env.NODE_ENV,
	TARGET: process.env.TARGET,
	BROWSER: process.env.BROWSER,
	REAL_BROWSER: process.env.REAL_BROWSER	
}